import React, { useEffect, useRef, useState } from 'react';

export default function FormSelect({
  value,
  onChange,
  options = [],
  placeholder = '',
  disabled = false,
  className = '',
  controlClassName = '',
  ariaLabel,
  icon = null,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('keydown', handleEscape);
    }
    return () => document.removeEventListener('keydown', handleEscape);
  }, [open]);

  const selectedOption = options.find((option) => String(option.value) === String(value));
  const displayLabel = selectedOption?.label || placeholder || '';

  const handleSelect = (optionValue) => {
    if (disabled) return;
    onChange?.(optionValue);
    setOpen(false);
  };

  return (
    <div
      ref={wrapRef}
      className={`form-select-custom ${open ? 'open' : ''} ${disabled ? 'disabled' : ''} ${className}`.trim()}
    >
      <button
        type="button"
        className={`form-select-custom-trigger ${!selectedOption && placeholder ? 'placeholder' : ''} ${controlClassName}`.trim()}
        onClick={() => !disabled && setOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={ariaLabel}
        disabled={disabled}
      >
        {icon && <span className="form-select-custom-icon" aria-hidden="true">{icon}</span>}
        <span className="form-select-custom-text">{displayLabel}</span>
        <span className="form-select-custom-caret" />
      </button>
      {open && !disabled && (
        <div className="form-select-custom-menu" role="listbox">
          <div className="form-select-custom-menu-inner">
            {options.map((option) => {
              const isSelected = String(option.value) === String(value);
              return (
                <button
                  type="button"
                  key={String(option.value)}
                  className={`form-select-custom-item ${isSelected ? 'selected' : ''}`}
                  role="option"
                  aria-selected={isSelected}
                  onClick={() => handleSelect(option.value)}
                  disabled={option.disabled}
                >
                  <span>{option.label}</span>
                  {isSelected && <span className="form-select-custom-check" />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
